module.exports = __webpack_public_path__ + "0ab8db26a9b251dfff09dd6afb1ad31d.jpeg";